var _path, _path2, _path3, _path4, _path5, _circle, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuditLogs = function SvgAuditLogs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M4.974 4a2 2 0 0 0-2 2v8.81a2 2 0 0 0 2 2h22.688a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm3.338 4.905a1.5 1.5 0 0 0 0 3h16.013a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M38.068 4a2 2 0 0 0-2 2v8.81a2 2 0 0 0 2 2h26.958a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm4.405 4.905a1.5 1.5 0 0 0 0 3H60.62a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M43.405 28.553a2 2 0 0 0-2 2v8.81a2 2 0 0 0 2 2h21.62a2 2 0 0 0 2-2v-8.81a2 2 0 0 0-2-2zm2.27 4.905a1.5 1.5 0 1 0 0 3h16.013a1.5 1.5 0 1 0 0-3z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    fillRule: "evenodd",
    d: "M4.974 28.553a2 2 0 0 0-2 2v8.81a2 2 0 0 0 2 2H33a2 2 0 0 0 2-2v-8.81a2 2 0 0 0-2-2zm3.338 4.905a1.5 1.5 0 0 0 0 3h20.283a1.5 1.5 0 1 0 0-3zM25.257 53.106a2 2 0 0 0-2 2v8.81a2 2 0 0 0 2 2h39.769a2 2 0 0 0 2-2v-8.81a2 2 0 0 0-2-2zm3.338 4.905a1.5 1.5 0 0 0 0 3h33.093a1.5 1.5 0 1 0 0-3z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M4.974 53.106a2 2 0 0 0-2 2v8.81a2 2 0 0 0 2 2h9.878a2 2 0 0 0 2-2v-8.81a2 2 0 0 0-2-2zm3.338 4.905a1.5 1.5 0 0 0 0 3h3.202a1.5 1.5 0 1 0 0-3z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.103,
    cy: 34.467,
    r: 13.24,
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    transform: "rotate(-45 28.103 34.467)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m37.465 43.829 14.043 14.043"
  })));
};
export default SvgAuditLogs;